import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatastoreService {
  idLocalAddress: boolean;
  basketItem: any;
  public config: any;
  registration: string;
  checkUser: any;
  addressLookupUnavailable: boolean = false;

  constructor() { }

  public vehicleStatus;

  public parentDepartment;

  public selectedDepartment;

  public bookingQuestions = [];

  public bookingForm;

  public selectedDate;

  public selectedSlot;

  public locations = [];

  public bookingAnswers;

  public customerDetailsForm;

  public client;

  public address;

  public latitude;

  public longitude;

  public endSlot;

  public customerQuestions;

  public address1;

  public extra;

  public banned: boolean;

  public observe: boolean;

  public clientCreated: boolean;

  notify: Subject<boolean> = new Subject<boolean>();
  onNotify(event) {
    this.notify.next(true);
  }

  public selectedChild: any = {};

  viewedEvent: any = {}

  timer = false;

  formData: any = {};

  public childrenToRegister: any[] = [];


}

